import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import ReactPhoneInput from "react-phone-input-2";
import * as otpGenerator from "otp-generator";
import * as validator from "validator";

// GraphQL
import CreateCustomerMutation from "../../GraphQL/Mutations/CreateCustomer";
import GetCompanyCustomers from "../../GraphQL/Queries/GetCompanyCustomers";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  closeModal(): void;
  notification(message: string): void;
}

class AddCustomerForm extends React.Component<IProps> {
  state = {
    name: "",
    address: "",
    email: "",
    phoneNumber: "",
    loading: false,
    error: null
  };

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "customerName":
        this.setState({ name: value });
        break;
      case "address":
        this.setState({ address: value });
        break;
      case "email":
        this.setState({ email: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { name, email } = this.state;
    // Check for undefined or empty infput fields
    if (!name || !email) {
      this.setError("Please fill in the name and email of the customer");
      return false;
    }
    // Validate email
    if (!validator.isEmail(email)) {
      this.setError("Please enter a valid email address.");
      return false;
    }

    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { name, address, phoneNumber, email } = this.state;
    const { companyId, closeModal, notification } = this.props;

    return (
      <Mutation<{}, {}> mutation={CreateCustomerMutation}>
        {(createSite, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                createSite({
                  variables: {
                    name,
                    address,
                    email,
                    phoneNumber,
                    customerRequestCode: otpGenerator.generate(8, {
                      upperCase: true,
                      specialChars: true
                    }),
                    companyId
                  },
                  refetchQueries: [
                    {
                      query: GetCompanyCustomers,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("Customer created successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="customerName">Customer Name</Label>
              <Input
                type="text"
                name="customerName"
                id="customerName"
                placeholder="Customer name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email Address</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="physicalAddress">Physical Address</Label>
              <Input
                type="text"
                name="address"
                id="physicalAddress"
                placeholder="Physical address"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Phone Number</Label>
              <ReactPhoneInput
                value={phoneNumber}
                defaultCountry={"za"}
                onChange={(customerPhoneNumber: any) =>
                  this.setState({ phoneNumber: customerPhoneNumber })
                }
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Save</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default AddCustomerForm;



// WEBPACK FOOTER //
// ./src/Containers/Customers/AddCustomerForm.tsx